export enum BugType {
  TAB_DEVICE = 'TAB_DEVICE',
  DEVICE_UNAVAILABLE = 'DEVICE_UNAVAILABLE',
  DDD_FILES = 'DDD_FILES',
  SERVICES = 'SERVICES',
  OTHER = 'OTHER'
}
